import { ActivityType } from "../../types/activityType";
import { ActionType } from "../action-types/index"
import { Action } from "../actions"


export type activitiesReducerType = {
    selected?:ActivityType, 
    array:ActivityType[]
}

const initialState:activitiesReducerType= {selected:undefined, array:[]};

const activitiesReducer = (state:activitiesReducerType = initialState, action: Action): activitiesReducerType => {
    switch (action.type){
        case ActionType.ADD_ACTIVITIES:
            return { ...state, array:[ ...state.array.filter(e => action.payload.includes(e)), ...action.payload] };
        case ActionType.SET_ACTIVITIES:
            return { ...state, array:action.payload };
        case ActionType.SET_SELECTED_ACTIVITY:
            return { ...state, selected:action.payload}
        default:
            return state
    }
}

export default activitiesReducer